import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconRefresh(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.981 6.762c-.007.051-.011.102-.031.151-.019.051-.053.092-.084.135-.017.025-.026.054-.047.077l-.008.005a.647.647 0 0 1-.211.147l-.007.005a.665.665 0 0 1-.261.053h-4a.667.667 0 1 1 0-1.334h2.317l-1.867-1.754a5.404 5.404 0 0 0-2.009-1.272c-1.344-.476-2.791-.399-4.076.215S3.442 4.881 2.966 6.224a.668.668 0 0 1-1.258-.445 6.624 6.624 0 0 1 3.414-3.793 6.617 6.617 0 0 1 5.095-.268 6.706 6.706 0 0 1 2.491 1.571l1.955 1.837V2.667a.667.667 0 0 1 1.334 0v4c0 .033-.014.062-.019.094zm-2.098 2.612a.665.665 0 0 1 .405.851 6.706 6.706 0 0 1-1.571 2.491 6.625 6.625 0 0 1-4.713 1.951h-.001a6.632 6.632 0 0 1-4.714-1.953l-1.955-1.837v2.459a.667.667 0 1 1-1.334 0v-4c0-.033.014-.062.019-.095.007-.05.011-.101.03-.149.02-.051.053-.092.084-.136.018-.025.026-.053.047-.076.003-.003.006-.003.008-.006.041-.041.092-.071.143-.101.025-.015.045-.037.071-.049.027-.011.06-.011.089-.02.055-.015.109-.033.166-.033l.01-.002h4a.667.667 0 0 1 0 1.334H2.35l1.867 1.755a5.312 5.312 0 0 0 3.786 1.577h.001a5.305 5.305 0 0 0 3.771-1.561 5.383 5.383 0 0 0 1.258-1.994.664.664 0 0 1 .851-.405z"
  }));
}
IconRefresh.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconRefresh.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconRefresh as default };
